export enum DLPageTypeEnum {
  START_PAGE = 'StartPage',
  SEARCH_PAGE = 'SearchPage',
  CARE_PROVIDER_PAGE = 'CareProviderPage',
  CARE_SERVICE_PAGE = 'CareServicePage',
  HSA_CARE_PROVIDER_PAGE = 'HsaCareProviderPage',
  BOOKING_PAGE = 'BookingPage',
  GUIDE_PAGE = 'GuidePage',
  ARTICLE_PAGE = 'ArticlePage',
  BLOG_PAGE = 'BlogPage',
  OTHER_PAGE = 'OtherPage',
  CARE_SERVICE_TYPE_PAGE = 'CareServiceTypePage',
  SYMPTOM_PAGE = 'SymptomPage',
  SERP_RELATED_PAGE = 'SerpRelatedPage',
}

export enum DLSegmentEnum {
  NOT_SET = 'NotSet',
}

export enum DLConversionTrackingEnum {
  INTERNAL = 'Internal',
  EXTERNAL_BOOKING_TRACKED = 'ExternalBookingTracked',
  EXTERNAL_BOOKING_UNTRACKED = 'ExtarnalBookingUntracked',
  CLICKS_TRACKED = 'ClicksTracked',
}
